import React from "react";
import { Pagination } from "react-bootstrap";
import "./Pagination.css";
const PaginationComponent = ({
  totalItems,
  pageSize,
  currentPage,
  setPage,
  onPageChange,
  rowsPerPage,
  setRowsPerPage,
}) => {
  const totalPages = Math.ceil(totalItems / pageSize);

  const handlePageChange = (pageNumber) => {
    onPageChange(pageNumber);
  };

  const renderPaginationItems = () => {
    let items = [];

    items.push(
      <Pagination.Prev
        key="prev"
        onClick={() => handlePageChange(currentPage > 1 ? currentPage - 1 : 1)}
        disabled={currentPage === 1}
      />
    );

    for (let number = 1; number <= totalPages; number++) {
      if (
        number === 1 ||
        number === totalPages ||
        (number >= currentPage - 1 && number <= currentPage + 1) ||
        number % 3 === 0
      ) {
        items.push(
          <Pagination.Item
            key={number}
            active={number === currentPage}
            onClick={() => handlePageChange(number)}
          >
            {number}
          </Pagination.Item>
        );
      } else if (number % 3 === 1 && number !== 1 && number !== totalPages) {
        items.push(<Pagination.Ellipsis key={`ellipsis-${number}`} />);
      }
    }

    items.push(
      <Pagination.Next
        key="next"
        onClick={() =>
          handlePageChange(
            currentPage < totalPages ? currentPage + 1 : totalPages
          )
        }
        disabled={currentPage === totalPages}
      />
    );

    return items;
  };

  return (
    <div className="container">
      <div className="pagination-pg">
        <div className="row">
          <div className="col-lg-2">
            <div className="empty-div"></div>
          </div>
          <div className="col-lg-8 col-md-9 col-12 pagination-center">
            <div className="">
              <Pagination>{renderPaginationItems()}</Pagination>
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-12 select-page-div pagination-select">
            <p> Rows per page</p>
            <select
              aria-label="Rows per page:"
              className=""
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setPage(1);
              }}
              // paginationPerPage={rowsPerPage}
              // onChangeRowsPerPage={(newPerPage) => setRowsPerPage(newPerPage)}
            >
              <option value="25" selected="">
                25
              </option>
              <option value="50">50</option>
              <option value="75">75</option>
              <option value="100">100</option>
              {/* <option value="30">30</option> */}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaginationComponent;
